define([
  'react',
  'immutable',
  'underscore',
  'es6!sumo/util',
  'es6!launcher/util/listbuilder/constants',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, Immutable, _, Util, Constants, Component) => {

  const { classNames } = Util;

  /**
   * Find the nearest ancestor column of the given 'el'
   */
  function getNearestAncestorByClass(el, className) {
    let nearestAncestorColumn;
    let parent = el;

    while ((parent = parent.parentNode)) {
      if (parent.className.indexOf(className) !== -1) {
        nearestAncestorColumn = parent;
        break;
      }
    }

    return nearestAncestorColumn;
  }

  /**
   * Component will linearly scale to fit it's parent, maintaining aspect ratio.  Same concept as
   * CSS background size option `contain`
   */
  @Component()
  class ScaledStage extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        containerWidth: 0,
        containerHeight: 0,
      };

      this.onResizeWindow = this.onResizeWindow.bind(this);
      this.saveContainer = this.saveContainer.bind(this);
    }

    componentDidMount() {
      window.addEventListener('resize', this.onResizeWindow, true);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onResizeWindow, true);
    }

    componentWillUpdate() {
      this.updateContainerDimensions();
    }

    componentDidUpdate() {
      this.updateContainerDimensions();
    }

    onResizeWindow() {
      // Rerender so we recalculate the size.
      this.updateContainerDimensions();
    }

    saveContainer(container) {
      if (!this.container) {
        // we have to jump past the immediate ancestors (component HOC wrapper, and move handle)
        this.container = getNearestAncestorByClass(container, 'sumome-react-wysiwyg-gridColumn');
        this.updateContainerDimensions();
      }

      if (!this.scaledStage) {
        this.scaledStage = getNearestAncestorByClass(container, 'sumome-react-wysiwyg-scaledStage');
        this.updateStageScale();
      }
    }

    updateContainerDimensions() {
      if (!this.container) return;
      const { containerWidth, containerHeight } = this.state;
      const newWidth = this.container.clientWidth;
      const newHeight = this.container.clientHeight;

      if (containerWidth !== newWidth || containerHeight !== newHeight) {
        this.setState({ containerWidth: newWidth, containerHeight: newHeight });
      }
    }

    updateStageScale() {
      if (!this.ratio || !this.scaledStage) return;

      const { childComponents } = this.props;
      const hasSocialButton = _.filter(childComponents.toJS(), component => component.type === 'socialButton').length > 0;

      this.scaledStage.style.transform = 'scale(' + this.ratio + ')';
    }

    getContainerDimensions() {
      let dimensions;
      if (this.container) {
        dimensions = {
          containerWidth: this.container.clientWidth || window.innerWidth,
          containerHeight: this.container.clientHeight || window.innerHeight,
        }
      } else {
        dimensions = { containerWidth: 0, containerHeight: 0 };
      }

      return dimensions;
    }

    getRatio(width, height) {
      const { containerWidth, containerHeight } = this.getContainerDimensions();

      // Don't scale if needed variables don't exist.
      if (!containerWidth || !containerHeight || !width || !height) return 1;
      return Math.min(Math.min(containerHeight, window.innerHeight) / height, Math.min(containerWidth, window.innerWidth) / width);
    }

    renderChildComponents() {
      const { childComponents, renderComponent, popupScaleRatio } = this.props;

      return childComponents.map(component => renderComponent(component, { scaleRatio: popupScaleRatio * this.ratio }));
    }

    render() {
      const { style } = this.props;
      const width = style.get('width');
      const height = style.get('height');
      this.ratio = this.getRatio(parseFloat(width), parseFloat(height));
      const containerStyle = {
        width,
        height,
      };

      if (this.scaledStage) {
        this.updateStageScale();
      }

      return (
        <div className='sumome-wysiwyg-scaledStage-contents' style={containerStyle} ref={this.saveContainer}>
          {this.renderChildComponents()}
        </div>
      );
    }
  }

  return ScaledStage;
});
